<template>
	<div v-if="isUserAllowedInLevel5or6">
		<BaseHeader :title="$t('store_customer').toString()" />

		<div class="main">
			<CustomerForm v-if="!isLoading" ref="CustomerForm" @updateValue="customer = $event" :start-value="customer" />
			<LoadingSpinner v-else />
		</div>

		<Footer @backButtonClick="goBack" :is-continue-button="false" :is-skippable="false" :is-back-button="true" class="m-8">
			<template #right>
				<BaseButton @click="next('end')" :disabled="isLoading" class="btn-blue">{{ $t('save_and_exit') }}</BaseButton>
				<BaseButton @click="next('newCar')" :disabled="isLoading" class="ml-4 btn-blue">
					<div class="flex flex-row items-center justify-between">
						<span>{{ $t('save_and_new_vehicle') }}</span>
					</div>
				</BaseButton>
			</template>
		</Footer>
	</div>
	<Forbidden v-else />
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader';
import CustomerForm from '@/components/forms/CustomerForm';
import BaseButton from '@/components/forms/buttons/BaseButton';
import { CustomersApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import Footer from '@/components/damagecases/Footer';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden.vue';

const customersApi = CustomersApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios);

export default {
	name: 'CustomerCreate',
	components: { Forbidden, LoadingSpinner, Footer, BaseButton, CustomerForm, BaseHeader },
	mixins: [Authentication],
	data() {
		return {
			isLoading: false,
			customer: {},
		};
	},
	created() {
		if (this.isUserAllowedInLevel5or6) {
			if (this.$route.params.customer) {
				customersApi.customersIdGet(this.$route.params.customer).then(response => {
					this.customer = response.data;
				});
			}
			this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
		}
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
		next(type) {
			if (this.$refs.CustomerForm.validate()) {
				this.isLoading = true;
				if (this.$route.params.customer) {
					// Update
					customersApi
						.customersIdPut(this.$route.params.customer, this.customer)
						.then(response => {
							if (response.data.id) {
								this.$swal({
									title: this.$t('general.success').toString(),
									text: this.$t('customer_saved_successfully').toString(),
									icon: 'success',
								}).then(result => {
									this.isLoading = false;
									this.$store.commit('setConfirmLeaving', false);
									if (type === 'end') {
										this.$router.push({ path: '/management/customer/overview/' + this.$route.params.customer });
									} else {
										this.$router.push({
											name: 'management.process.create_vehicle',
											params: { customer: this.$route.params.customer, ref: 'customerCreate' },
										});
									}
								});
							} else {
								this.$swal(this.$t('general.attention').toString(), this.$t('error_saving').toString(), 'warning');
							}
						})
						.catch(error => {
							this.isLoading = false;
							this.isSearchRunning = false;
						});
				} else {
					// Create
					CustomersApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
						.customersPost(this.customer)
						.then(response => {
							if (response.data.id) {
								this.isLoading = false;
								this.$swal({
									title: this.$t('general.success').toString(),
									text: this.$t('customer_saved_successfully').toString(),
									icon: 'success',
								}).then(result => {
									this.$store.commit('setConfirmLeaving', false);
									if (type === 'end') {
										this.$router.push({ path: '/management/customer/overview/' + response.data.id });
									} else {
										this.$router.push({
											name: 'management.process.create_vehicle',
											params: { type: 'vehicle', customer: response.data.id, ref: 'customerCreate' },
										});
									}
								});
							} else {
								this.isLoading = false;
								this.$swal(this.$t('general.attention').toString(), this.$t('error_saving').toString(), 'warning');
							}
						})
						.catch(error => {
							this.isLoading = false;
							this.$swal(this.$t('general.error').toString(), this.$t('error_saving').toString(), 'error');
							this.isSearchRunning = false;
						});
				}
			} else {
				this.isLoading = false;
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
	},
};
</script>

<style scoped></style>
